import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/booster-blue.svg'
import _imports_1 from '@/assets/sm-facebook.png'
import _imports_2 from '@/assets/sm-linkedin.png'
import _imports_3 from '@/assets/sm-youtube.png'


const _withScopeId = n => (_pushScopeId("data-v-7106de06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-5 pb-4" }
const _hoisted_2 = { class: "footer-content" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-10 text-start booster-footer" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-body-small" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.booster.co.nz/products-services/insurance/booster-smartcover",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-globe2 pe-1" }),
    /*#__PURE__*/_createTextVNode(" booster.co.nz ")
  ])
], -1))
const _hoisted_6 = { class: "item-body-small" }
const _hoisted_7 = {
  href: "mailto:adviserservices@booster.co.nz",
  target: "_blank"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-send pe-1" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"item-body-small\" data-v-7106de06><i class=\"bi bi-telephone pe-1\" data-v-7106de06></i> 04 886 3206 </div><div class=\"item-body-small\" data-v-7106de06><i class=\"bi bi-envelope pe-1\" data-v-7106de06></i> PO Box 11872, Manners Street, Wellington </div><div class=\"item-body-small footer-links\" data-v-7106de06><a href=\"https://www.booster.co.nz/terms-and-conditions\" target=\"_blank\" data-v-7106de06><i class=\"bi bi-file-earmark-text pe-1\" data-v-7106de06></i>Terms and conditions</a><a href=\"https://www.booster.co.nz/privacy-policy\" target=\"_blank\" data-v-7106de06>Privacy</a><a href=\"https://www.booster.co.nz/why-booster/about-us\" target=\"_blank\" data-v-7106de06>About Booster</a></div>", 3)
const _hoisted_12 = {
  key: 0,
  class: "item-body-small footer-links"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.surveymonkey.com/r/293SGHC",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-star pe-1" }),
  /*#__PURE__*/_createTextVNode("Send feedback")
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-2 col-md-2 col-sm-12 col-12 text-end footer-logo\" data-v-7106de06><a href=\"https://www.booster.co.nz/\" target=\"_blank\" data-v-7106de06><img class=\"logo\" alt=\"Booster\" src=\"" + _imports_0 + "\" data-v-7106de06></a><div class=\"d-flex pt-4 align-items-center justify-content-end footer-social-icon\" data-v-7106de06><a href=\"https://www.facebook.com/boosternz/\" target=\"_blank\" data-v-7106de06><img class=\"logo-icon me-1\" src=\"" + _imports_1 + "\" data-v-7106de06></a><a href=\"https://www.linkedin.com/company/boosternz/\" target=\"_blank\" data-v-7106de06><img class=\"logo-icon me-1\" src=\"" + _imports_2 + "\" data-v-7106de06></a><a href=\"https://www.youtube.com/@BoosterNz\" target=\"_blank\" data-v-7106de06><img class=\"logo-icon\" src=\"" + _imports_3 + "\" data-v-7106de06></a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("a", _hoisted_7, [
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.email) + "@booster.co.nz ", 1)
            ])
          ]),
          _hoisted_9,
          (_ctx.canViewInvestments)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
            : _createCommentVNode("", true)
        ]),
        _hoisted_15
      ])
    ])
  ]))
}